<div class="signin-box-container scroll-bar-css reset-password-page">
  <div class="signin-box-inner-container">
    <div class="col-12 sign-in-text">
      <div class="lg:col-6 lg:col-offset-3 md:col-8 md:col-offset-2 sm:col-12 sm:col-offset-0 sign-in-content">
        {{signInDescription}}
      </div>
    </div>

    <div class="grid justify-content-center reset-password-form-row">
      <div class="col-12 sm:col-10 md:col-5 lg:col-4 xl:col-4">
        <p-panel styleClass="reset-password-panel">
          <div class="form-field col-12">
            <div class="text-center"><img [src]="logoPath"></div>
            <div class="form-field col-12 switch-btn">Reset Password</div>
          </div>

          <div class="form-field col-12">
            <div class="form-errors alert alert-danger" [hidden]="!changePasswordErrors[0]['general']">
              <div *ngFor="let ErrorMessage of changePasswordErrors['general']">
                {{ErrorMessage.message}}
              </div>
            </div>
          </div>

          <form [formGroup]="setPasswordForm" class="reset-password-form">
            <div class="form-field col-12">
              <div class="form-label">
                <label for="email-label" translate>label_new_password</label>
              </div>
              <div class="form-control">
                <p-password formControlName="newPassword" [toggleMask]="true" [feedback]="false"
                  [style]="{'width': '100%'}" [inputStyle]="{'width': '100%'}"></p-password>

                <div class="form-errors"
                  *ngIf="setPasswordForm.controls.newPassword.errors && (setPasswordForm.controls.newPassword.dirty || setPasswordForm.controls.newPassword.touched)">
                  <div [hidden]="!setPasswordForm.controls.newPassword.errors.required" translate>
                    error_new_password_required
                  </div>
                  <div
                    [hidden]="!setPasswordForm.controls.newPassword.errors.minlength && !setPasswordForm.controls.newPassword.errors.pattern"
                    translate>
                    error_password_validation
                  </div>
                </div>
              </div>
            </div>

            <div class="form-field col-12">
              <div class="form-label">
                <label for="newConfirmPassword" translate>label_new_confirm_password</label>
              </div>
              <div class="form-control">
                <p-password formControlName="newConfirmPassword" [toggleMask]="true" [feedback]="false"
                  [style]="{'width': '100%'}" [inputStyle]="{'width': '100%'}"></p-password>

                <div class="form-errors"
                  *ngIf="(setPasswordForm.controls.newConfirmPassword.errors && (setPasswordForm.controls.newConfirmPassword.dirty || setPasswordForm.controls.newConfirmPassword.touched)) || showPasswordMismatchError()">
                  <div [hidden]="!setPasswordForm.controls.newConfirmPassword.errors?.required" translate>
                    error_new_confirm_password_required
                  </div>
                  <div
                    [hidden]="!setPasswordForm.controls.newConfirmPassword.errors?.minlength && !setPasswordForm.controls.newConfirmPassword.errors?.pattern"
                    translate>
                    error_password_validation
                  </div>
                  <div *ngIf="showPasswordMismatchError()" translate class="text-sm">
                    error_new_confirm_password_not_match
                  </div>
                </div>
              </div>
            </div>

            <div class="form-field col-12">
              <button pButton appRipple label="Reset" class="sign-in-buttons" type="button"
                [disabled]="!setPasswordForm.valid || showPasswordMismatchError()"
                (click)="doChangePassword()"></button>
            </div>
          </form>
        </p-panel>
      </div>
    </div>
  </div>
</div>
